import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import TsGrid from "../../../components/tsGrid";
import { getWorkItemStateDefs } from "./workItemStatesDefs";
import { MyContext } from "../../../context/myContext";
import useApi from "../../../hooks/useApi";
import workItemState from "../../../api/WorkItemState";
import { toast } from "react-toastify";
import { StateCategory } from "../workitem-state-categories/WorkItemStateCategory";


export type WorkItemState = {
  state: string,
  category: string,
  state_description: string

}

const WorkItemStatesTable = ({ getData, data }: any) => {
  const { selectedProduct } = useContext<any>(MyContext);
  const saveWorkItemStateApi = useApi(workItemState.saveWorkItemState)
  const gridStyle = useMemo(() => ({ height: '90%', width: '100%', padding: "0px !important" }), []);
  const [categoryList, setCategoryList] = useState([])
  const [uniqueWorkItemState, setUniqueWorkItemState] = useState<string[]>([])
  const gridRef = useRef<any>(null);
  const gridApiRef = useRef<any>(null);

  const descriptionOptions = useMemo(() => {
    return ([
      { id: 'Initial State', name: 'Initial State' },
      { id: 'Development Started', name: 'Development Started' },
      { id: 'Development Completed', name: 'Development Completed' },
      { id: 'Release Completed', name: 'Release Completed' }
    ])
  }, [])

  const [rowData, setRowData] = useState<WorkItemState[]>([]);

  const saveStateCategory = async (data: WorkItemState) => {
    try {
      const obj = {
        ...data,
        state: data?.state.trim(),
        category: data?.category ?? '',
        state_description: data?.state_description ?? ''
      }
      const response = await saveWorkItemStateApi.request(selectedProduct, obj)
      if (response?.data) {
        getData()
      }
    }
    catch (err) {

    }
  }

  const fetchData = async () => {
    const respose = data?.data?.data

    const categoryOrder :any = {};
    respose.workItemStateCategories.forEach((category:StateCategory, index:number) => {
      categoryOrder[category.name] = index;
    });

    const sortedWorkItemStates = [...respose.workItemStates].sort((a, b) => {
      return categoryOrder[a.category] - categoryOrder[b.category];
    });

    setRowData([...sortedWorkItemStates, { state: '' }])
    setCategoryList(respose?.workItemStateCategories)
    const states:string[] = sortedWorkItemStates?.map((item: any) => { return item.state })


    setUniqueWorkItemState(states)

  }

  useEffect(() => {
    if (data?.data?.data)
      fetchData()
  }, [data?.data?.data])


  const onGridReady = useCallback((params: any) => {
    gridApiRef.current = params.api;
    params.api.sizeColumnsToFit();
  }, []);

  const scrollToBottom = useCallback(() => {
    if (gridApiRef.current) {
      const rowCount = gridApiRef.current.getDisplayedRowCount();
      gridApiRef.current.ensureIndexVisible(rowCount - 1, "bottom");
    }
  }, []);

  const addNewRow = useCallback(() => {
    const newItem = { state: '' };
    if (gridApiRef.current) {
      gridApiRef.current.applyTransaction({ add: [newItem] });
      setTimeout(() => {
        scrollToBottom();
      }, 10);
    }
  }, [scrollToBottom]);


  const columnDefs = useMemo(() => getWorkItemStateDefs({
    getData,
    selectedProduct,
    categoryList,
    descriptionOptions
  }), [addNewRow, rowData, getData, selectedProduct, categoryList, descriptionOptions]);


  const onHandleCellValueChanged = useCallback((params: any) => {
    const rowCount = gridApiRef.current.getDisplayedRowCount();
    const lastRowIndex = rowCount - 1;
    const data = params.data;

    if (params?.colDef?.field === 'state') {
      data['state'] = params?.data?.state;
      const isAlreadyPresent = uniqueWorkItemState.find((item: any) => (item?.trim().toLowerCase() === params?.data?.state?.trim().toLowerCase()));

      if (isAlreadyPresent) {
        data['state'] = params?.oldValue;
        gridApiRef.current.applyTransaction({ update: [data] });
        toast.error('state name already present', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return
      } else if (params?.oldValue) {
        data['initialState'] = params?.oldValue;
      }


      if (params.rowIndex === lastRowIndex && data['state']) {
        addNewRow();
        gridApiRef.current.ensureIndexVisible(rowCount - 1, "bottom");
      }

    }
    gridApiRef.current.applyTransaction({ update: [data] });

    if (data?.state && data?.category) {
      data['category'] = params?.data?.category?.label ?? params?.data?.category;
      data['state_description'] = params?.data?.state_description?.label ?? params?.data?.state_description;
      saveStateCategory(data);
    }
  }, [rowData, uniqueWorkItemState])


  return (
    <div>
      <h1 className="page-heading">Work Item States</h1>
      <div style={{ height: '85vh' }} className={`ag-theme-alpine grid_style mt-[30px] pr-[10px]`}>
        <TsGrid
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={{ flex: 1, editable: true }}
          onGridReady={onGridReady}
          gridRef={gridRef}
          gridStyle={gridStyle}
          onCellValueChanged={onHandleCellValueChanged}
          editType={"fullRowInline"}
          singleClickEdit={true}
          stopEditingWhenCellsLoseFocus={true}
          virtualization={true}
          suppressScrollOnNewData={true}

        />
      </div>
    </div>
  );
};

export default WorkItemStatesTable;
